import { useEffect, useState } from "react";
import Banner from "../componenets/Banner";
import Products from "../componenets/Products";
import { useLoaderData } from "react-router-dom";
const Home=()=>{
    const[products,setproducts]=useState([]);
    const data=useLoaderData()
    useEffect(()=>{
        setproducts(data.data)
    },[data])
    console.log(data);
  
    return(<div>
    <Banner></Banner>
    <Products products={products}></Products>
    </div>);
}
export default Home;